import { compact, map } from 'lodash'
import React, { Component } from 'react'
import { ItemData } from '../apis/item.api'
import shipOrderApi from '../apis/shipOrder.api'
import ContentAside from '../components/ContentAside'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import ItemsCard from '../components/ItemsCard'
import ShipForm from '../partials/ShipForm'

interface ShipProps {}

interface ShipState {
  items: ItemData[]
}

export default class Ship extends Component<ShipProps, ShipState> {
  constructor (props: ShipProps) {
    super(props)
    this.state = {
      items: []
    }
    this.handleShipOrderSelect = this.handleShipOrderSelect.bind(this)
    this.handleReset = this.handleReset.bind(this)
  }

  get itemsData () {
    const data = map(this.state.items, item => {
      const { code, description, shipOrderItem } = item
      if (!shipOrderItem) return
      const { remainingQuantity } = shipOrderItem
      return { code, description, remainingQuantity }
    })
    return compact(data)
  }

  listShipOrderItems (id: number) {
    shipOrderApi.listItems(id, items => {
      if (!items) return
      this.setState({ items })
    })
  }

  handleShipOrderSelect (id: number | null) {
    if (!id) {
      this.setState({ items: [] })
      return
    }
    this.listShipOrderItems(id)
  }

  reset () {
    const defaultState: ShipState = { items: [] }
    this.setState(defaultState)
  }

  handleReset () {
    this.reset()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="twoThird">
          <ShipForm
            onShipOrderSelect={this.handleShipOrderSelect}
            onReset={this.handleReset} />
        </ContentMain>
        <ContentAside layout="oneThird">
        <ItemsCard items={this.itemsData} />
        </ContentAside>
      </ContentLayout>
    )
  }
}
